/* eslint-disable no-lonely-if */
import React from 'react';
import { icons } from '../../../../../configs/Icons';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
import { ButtonPest } from '../../../../utils/Button';
import { InputFieldSearch, SelectOption, addOption } from '../../../../utils/InputField';
import { useAdminListInfo } from '../AdminsListProvider';

function PageHeaderLeftCol({ handleChangeFilterData, p }) {
    return (
        <form className="customers_page_header_left_col flex-1 flex items-center gap-x-2 md:gap-x-4">
            <InputFieldSearch
                label="Search...."
                name="q"
                onChange={handleChangeFilterData}
                formData={p}
                className="rounded-10 w-76"
            />

            <SelectOption
                name="status"
                placeholder="Status"
                formData={p}
                onChange={handleChangeFilterData}
                options={['Active', 'Inactive']?.map((d) => addOption(d, d, d?.toLowerCase()))}
                className="rounded-10 w-38"
            />
        </form>
    );
}

function PageHeaderRightCol() {
    const { handleReload, openModal } = useAdminListInfo();

    return (
        <div className="customer_page_header_right_col flex-1 flex flex-row gap-2 justify-end items-center ">
            <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
            <ButtonPest
                type="button"
                onClick={() => openModal('create-new-admin')}
                className="flex items-center justify-between gap-2 h-8"
            >
                <img src={icons.plusW} alt="" className="w-3 h-3" />
                <span>Create Admin</span>
            </ButtonPest>
        </div>
    );
}

function PageHeader({ handleChangeFilterData, p }) {
    return (
        <div className="customer_page_header w-full mb-3 md:mb-7 flex flex-row justify-between items-center">
            <PageHeaderLeftCol handleChangeFilterData={handleChangeFilterData} p={p} />
            <PageHeaderRightCol />
        </div>
    );
}

export default PageHeader;
